import { defineGlobalStyles } from '@chakra-ui/react'

export const globalCss = defineGlobalStyles({
  html: {
    color: 'fg',
    bg: 'bg',
    lineHeight: '1.5',
    colorPalette: 'brand',
    // Mobile: prevent rubber-band overscroll past the fixed nav chrome and
    // remove the grey tap flash on touch targets. No effect on desktop.
    overscrollBehaviorY: 'none',
    WebkitTapHighlightColor: 'transparent',
  },
  // Respect the user's reduced-motion preference (WCAG 2.3.3). Neutralises all
  // CSS animations/transitions globally — covers Chakra `animation` props
  // (shimmer, pop, confetti keyframes) without touching each component.
  // JS-driven motion (canvas-confetti, driver.js product tour) is guarded
  // separately at its call sites.
  '*, *::before, *::after': {
    '@media (prefers-reduced-motion: reduce)': {
      animationDuration: '0.01ms !important',
      animationIterationCount: '1 !important',
      transitionDuration: '0.01ms !important',
      scrollBehavior: 'auto !important',
    },
  },
})
